<template>
  <a-tabs default-active-key="1">
    <a-tab-pane tab="CALENDARIO" key="1">
      <g-master :name="master.endpoint"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                modalWidth="70%"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Tipo de calendario')"
                          :formItemConfig="fiOptions"
                          :decorator="['type', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="tipo_calendario"
              >
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Año')" v-bind="fiOptions">
                <a-select :default-value="yearToday" v-decorator="['year', { rules: [
                            { required: false},
                           ] }]" style="width: 100%">
                  <a-select-option v-for="year_ in years" :key="year_">
                    {{ year_ }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Mes')" v-bind="fiOptions">
                <a-select v-decorator="['month', { rules: [
                            { required: false},
                           ] }]" style="width: 100%">
                  <a-select-option v-for="month_ in months_name" :key="month_.value">
                    {{ month_.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Tipo de pago')"
                          :formItemConfig="fiOptions"
                          :decorator="['tpay', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="tipo_pago">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Tipo de liquidación')"
                          :formItemConfig="fiOptions"
                          :decorator="['tliq', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="tipo_liquidacion">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown :label="$t('Período')"
                          :formItemConfig="fiOptions"
                          endpoint="hierarchy_lookup"
                          :decorator="['period']"
                          :params="periodo">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Proceso')"
                          :formItemConfig="fiOptions"
                          :decorator="['prc', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="proceso"></g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Fecha inicial')" v-bind="fiOptions">
                <a-date-picker style="width: 100%"
                               type="date"
                               valueFormat="Y-MM-DD HH:mm:ss"
                               v-decorator="['init_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Fecha final')" v-bind="fiOptions">
                <a-date-picker style="width: 100%"
                               type="date"
                               valueFormat="Y-MM-DD HH:mm:ss"
                               v-decorator="['end_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="Atributos del calendario" key="1">
          <atributos-calendario v-if="id" :id_calendar="id">
          </atributos-calendario>
          <span v-else>Seleccione un apartado para visualizar los atributos.</span>
        </a-tab-pane>
      </a-tabs>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
  export default {
    data () {
      return {
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        tipo_calendario: {
          h_lookup_type: 'TIPO_CALENDARIO',
          use_code: true
        },
        tipo_pago: {
          h_lookup_type: 'TIPO PAGO',
          use_code: true
        },
        periodo: {
          h_lookup_type: 'PERIODOS_LIQUIDACION',
          use_code: true
        },
        tipo_liquidacion: {
          h_lookup_type: 'TIPO_LIQUIDACION',
          use_code: true
        },
        proceso: {
          h_lookup_type: 'PROCESOS_LIQUIDACION',
          use_code: true,
          concat_text_code: true
        },
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          endpoint: 'calendars',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Tipo de calendario', dataIndex: 'type_desc', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'mes', sorter: true},
              {title: 'Período', dataIndex: 'period_desc', sorter: true},
              {title: 'Proceso', dataIndex: 'proceso', sorter: true},
              {title: 'Tipo de liquidación', dataIndex: 'tliq_desc', sorter: true},
              {title: 'Descripción tipo de pago', dataIndex: 'tpay_desc', sorter: true},
              {title: 'Fecha inicial', dataIndex: 'fecha_inicio', sorter: true},
              {title: 'Fecha final', dataIndex: 'fecha_fin', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'type'},
            {name: 'init_date'},
            {name: 'end_date'},
            {name: 'prc'},
            {name: 'period'},
            {name: 'tliq'},
            {name: 'tpay'},
            {name: 'year'},
            {name: 'month'}
          ]
        }
      }
    },
    mounted () {
      this.yearsSelect()
    },
    computed: {
      id () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      }
    },
    methods: {
      yearsSelect () {
        for (let i = (this.yearToday - 20); i <= (this.yearToday + 40); i++) {
          this.years.push(i)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Calendario/Calendario.vue